import { useEffect } from "react";
import { useFetch } from "./useFetch";
import { fetchVerificationById } from "../services/verificationsService";

export function useVerificationDetail(verificationId: string | undefined) {
  const { data, isLoading, error, fetchData } = useFetch(fetchVerificationById);

  useEffect(() => {
    if (verificationId) {
      fetchData(verificationId).catch(() => {
        // Failure is already captured in `error` state via useFetch; swallow
        // here so a network error doesn't surface as an unhandled rejection.
      });
    }
  }, [fetchData, verificationId]);

  return {
    verification: data,
    isLoading,
    error,
  };
}
